export default "__VITE_ASSET__890510b2__"